import React, { useState, useEffect, useCallback } from "react";

// Services
import { WorkflowApi } from "./../../services/WorkflowApi";
// Global Styles
import {
  Container,
  PageTitle,
  CustomButtonV2
} from "../styles";
// Moment JS
import moment from "moment";
import { BackdropLoading } from "../../components/BackdropLoading";
import AssignmentIcon from "@mui/icons-material/Assignment";
// Atoms Components
import { SearchBarLogs } from "../../components/atoms/searchBars/SearchBarLogs";
import { TableLogs } from "../../components/atoms/tables/TableLogs";
// Services
import { FormatDate } from "../../utils/formatDate";

// Utils
import { useTranslation } from "react-i18next";
import { ColorsContext } from "../../Context/ColorsContext";

//MUI Material
import { Grid, useTheme, useMediaQuery } from "@mui/material";

// Material Icons
import { CloudDownloadOutlined, SaveAltRounded } from "@mui/icons-material";

//Custom Hook
import { useDownloadExcel } from "../../Hooks/useDownloadExcel";

export const LogsList = (props) => {
  // constant Service
  const logsApi = new WorkflowApi();

  const { i18n, t } = useTranslation();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));
  const { colors } = React.useContext(ColorsContext);
  const { format } = new FormatDate();

  const [arrayLogs, setArrayLogs] = useState([]);
  const [rows, setRows] = useState([]);
  const [finalDate, setFinalDate] = useState(
    moment(new Date()).endOf("week").format("YYYY-MM-DD")
  );
  const [initialDate, setInitialDate] = useState(
    moment(new Date()).startOf("week").format("YYYY-MM-DD")
  );
  const [loading, setLoading] = React.useState(false);

  //?? prepare item-table for download Excel
  const fieldConfig = {
    [t("system.logs.table.date")]: (item) =>
      format({ date: item.createdAt, format: true }).toString(),
    [t("system.logs.table.user")]: "username",
    [t("system.logs.table.module")]: "module",
    [t("system.logs.table.submodule")]: "submodule",
    [t("common.actions.title")]: "action",
  };

  //?? Custom Hook Download Excel
  const { handleDownloadExcelList } = useDownloadExcel(
    arrayLogs,
    fieldConfig,
    t("system.logs.title")
  );

  const Loadlogs = useCallback(async (data) => {
    setLoading(true);
    let response = await logsApi.LoadLogs(data);
    if (response.status === 200) {
      let resp = response.data.data;
      setRows(resp);
      setArrayLogs(resp);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    // Loadlogs(logsFilter);
    Loadlogs({
      initDate: initialDate,
      finDate: finalDate,
    });
  }, [i18n.language]);

  // Metodo Onsubmit Form filter
  function handleDatesFilter(e) {
    e.preventDefault();
    const data = {
      initDate: initialDate,
      finDate: finalDate,
    };
    Loadlogs(data);
  }

  // Method Clear Filter
  const handleClearDate = () => {
    const newFinalDate = moment(new Date()).endOf("week").format("YYYY-MM-DD");
    const newInitialDate = moment(new Date())
      .startOf("week")
      .format("YYYY-MM-DD");

    setFinalDate(newFinalDate);
    setInitialDate(newInitialDate);

    Loadlogs({
      initDate: newInitialDate,
      finDate: newFinalDate,
    });
  };

  return (
    <>
      <Container open={props.open} style={{ marginBottom: 0 }}>
        <BackdropLoading open={loading} />

        <Grid container 
          spacing={1}
          alignItems="center"
          sx={{ mb: { md: 2 } }}
          columns={{ xs: 12, sm: 12, md: 12, lg: 23, xl: 12 }}
        >
          <Grid item xs={6} sm={9} md={10} lg={9} xl={4} sx={{ order: { xs: 1, lg: 1 } }}>
            <PageTitle>
              {t("system.logs.title")}
            </PageTitle>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={9} xl={4} sx={{ width: '100%', order: { xs: 3, lg: 2 }, mt: { xs: 1, lg: 0 } }}>
              <SearchBarLogs rows={rows} setArrayLogs={setArrayLogs} />
          </Grid>

          {isDesktop &&
            <Grid item md={false} lg={2} xl={3} sx={{ order: 3 }}></Grid>
          }

          <Grid item xs={6} sm={3} md={2} lg={3} xl={1}
            sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, order: { xs: 2, lg: 4 } }}>
              <CustomButtonV2
                variant="contained"
                startIcon={<SaveAltRounded />}
                aria-label="download"
                onClick={handleDownloadExcelList}
                sx={{ whiteSpace: 'nowrap' }}
              >
                {t("common.download")}
              </CustomButtonV2>
          </Grid>
        </Grid>

        <TableLogs
          rows={rows}
          setRows={setRows}
          arrayLogs={arrayLogs}
          setArrayLogs={setArrayLogs}
          initialDate={initialDate}
          setInitialDate={setInitialDate}
          finalDate={finalDate}
          setFinalDate={setFinalDate}
          handleDatesFilter={handleDatesFilter}
          handleClearDate={handleClearDate}
        />
      </Container>
    </>
  );
};
